import { Config } from './types/config';

let config: Config;

const environment = process.env.REACT_APP_ENVIRONMENT;
const apiUrl = process.env.REACT_APP_API_BASE_URL;
console.log('Current environment:', environment);
console.log('API URL:', apiUrl);
console.log('All environment variables:', process.env);

// Use API URL to determine which config to use
if (apiUrl?.includes('dev.gmr.eb.produtonics.com')) {
  console.log('Loading development config based on API URL');
  config = require('./config.dev').config;
} else if (apiUrl?.includes('gmr.eb.produtonics.com')) {
  console.log('Loading production config based on API URL');
  config = require('./config.prod').config;
} else {
  console.log('No matching API URL found, defaulting to development config');
  config = require('./config.dev').config;
}

console.log('Selected config:', config);

// Get the API URL from environment variable or use default
export const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/dev/api/v1';

export { config };
